'use client'

import { useCategories } from 'algolia/algolia.components'
import { useTranslations } from 'next-intl'

import { HeroBanner } from './hero-banner'

export function CategoryHeroBanner() {
  const t = useTranslations('pages.studio_templates')
  const { category, subcategory } = useCategories()

  const fullCategoryName = [subcategory, category].filter(Boolean).join(' ').toLowerCase()

  return (
    <HeroBanner
      title={t('new_hero.h1')?.replace('[0]', subcategory || category || '')}
      description={t('new_hero.desc')?.replace(/\[0]/g, fullCategoryName || 'templates')}
      breadCrumbs={[category, subcategory].filter(Boolean)}
    />
  )
}
